import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAlpinelinuxComponent } from './simple-icons-alpinelinux.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAlpinelinuxComponent ],
    exports:      [ SimpleIconsAlpinelinuxComponent ],
    bootstrap:    []
})
export class SimpleIconsAlpinelinuxModule {}
